import { useState, useEffect } from "react";
import {useLocation} from "react-router-dom";
import { ConsultaAPI } from "../../../../../shared/http-requests";
import DropDownSearch, { makeDataSource } from "./DropDownSearch";

/**
 * @author Renan Salustiano <renan.salustiano@ter.grupomarista.org.br>
 * @param setBiblioteca {function}
 * @returns {JSX.Element}
 * @constructor
 */
const DropDownInputBibliotecas = ({setBiblioteca, campus}) => {
    const [data, setData] = useState()
    const [pagination, setPagination] = useState();
    const [loading, setLoading] = useState(false);
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const [selected, setSelected] = useState(0);



    useEffect(() => {
        const codCampus = campus?.id || null;
        buscaBibliotecas(null, 1, codCampus);
    }, [campus]);


    /**
     * Busca o dado pelo id caso seja um acesso direto pela url
     */
    useEffect(() => {
        const biblioteca  = params.get('biblioteca');

        if(biblioteca){
            ConsultaAPI.buscarBibliotecaPorCodigo(biblioteca).then((response) => {
                const { data } = response;
                if(data){

                    const config = {
                        id: 'cod_biblioteca',
                        key: 'cod_biblioteca',
                        text: 'desc_biblioteca'
                    };

                    const parsedData = makeDataSource([data], config);
                    setBiblioteca(parsedData[0])
                    setSelected(data?.cod_biblioteca)
                    setData(parsedData);
                }
            }).catch((error) => {
                console.log(error)
            })
        }
    }, []);

    const buscaBibliotecas = (text = '', page= 1) => {
        const codCampus = campus?.id || null;

        setLoading(true);
        return  ConsultaAPI.buscarBibliotecas(text, page, codCampus).then((response) => {
            const { data } = response;
            if(data){
                const { results, totalPages, currentPage } = data;
                setPagination({totalPages, currentPage});

                const config = {
                    id: 'cod_biblioteca',
                    key: 'cod_biblioteca',
                    text: 'desc_biblioteca'
                }

                setData(makeDataSource(results, config));
            }
            setLoading(false);
        }).catch( error => {
            setLoading(false)
            console.log(error);
        });
    }

    return (
        <DropDownSearch
            placeholder="Selecione uma unidade de informação"
            loading={loading}
            customFilter
            data={data}
            value={selected}
            onChange={buscaBibliotecas}
            onSelect={(item) => {
                setBiblioteca(item);
            }}
            pagination={pagination}
        />
    )
}

export default DropDownInputBibliotecas;
